import axios from 'axios';

let BASE_URL = `${window.location.origin}/api/v1`;

const config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
  }
};

const client = {
  get(path, params) {
    return axios.get(`${BASE_URL}${path}?${params}`, config)
  },
}

export default client;
